import React from 'react';
import { Item } from 'components';
import classnames from 'classnames';

const Catalog = (props) => {
  const {
    items,
    className = '',
    passedClass,
    xl,
    to,
    ...rest
  } = props;

  return (
    <div className={classnames('Catalog', { xl }, className)}>
      {items && items.map((item) => (
        <div className={passedClass || "item-container"} key={`${item.slug}-${item.id}`}>
          <Item
            {...item}
            {...rest}
            to={to}
          />
        </div>
      ))}
    </div>
  );
};

export default Catalog;
